import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get, isEqual } from 'lodash';
import { appointmentSpecialitiesActions } from '../../../src/actions';
import ProgressiveSelect from './ProgressiveSelect';

const SpecialitySelect = ({ card, ...props }: any) => {
  const dispatch = useDispatch();
  const centerId = card.center.id;
  const items = useSelector(
    state => get(state, 'appointmentSpecialities.items'),
    (oldValue, newValue) =>
      isEqual(
        oldValue.map(({ id }) => id),
        newValue.map(({ id }) => id),
      ),
  );
  useEffect(() => {
    dispatch(
      appointmentSpecialitiesActions.getList({
        rootCenterId: centerId,
      }),
    );
  }, [centerId, dispatch]);

  return (
    <ProgressiveSelect
      options={items}
      defaultLabel="Choisir une spécialité"
      optionRender={({ name }) => name}
      {...props}
      autoSelectIfOnlyOneOption
    />
  );
};

export default SpecialitySelect;
